export const classes = {
  link: 'cursor-pointer border-none bg-transparent font-semibold text-taupe-2 underline underline-offset-[3px] transition-colors duration-[140ms] ease-[ease] hover:text-taupe-3 dark:text-mauve-2 dark:hover:text-mauve-1',
  default: 'text-sm',
  sm: 'text-[13px] font-medium',
};
